var _g, _g2, _g3, _g4, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSecondLeft = function SvgSecondLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 81,
    viewBox: "0 0 77 81",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_27_5422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6752 55.3151C21.1138 48.8418 22.0235 43.5 20.0581 38.0574C20.3865 29.5054 27.199 47.5552 33.6973 51.3946C45.8129 58.553 56.6426 57.4056 62.2143 55.8312C62.9858 55.4719 63.7303 55.1145 64.4495 54.773C67.5511 53.3005 66.2884 54.68 62.2143 55.8312C55.1084 59.1408 45.7115 62.6144 32.6752 55.3151Z",
    fill: "currentColor",
    fillOpacity: 0.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_27_5422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4082 24.5514C17.0206 23.7855 14.9467 24.7783 14.6417 23.6714C14.3366 22.5644 16.614 23.0297 17.1645 22.2685C17.7151 21.5074 17.021 21.4807 16.722 20.2175C16.4229 18.9543 18.3436 18.7152 19.0197 19.2105C19.6958 19.7059 19.1032 21.5607 19.7973 21.5873C20.4914 21.614 22.704 21.2727 22.6373 23.0112C22.6073 23.7916 19.7321 23.2865 19.6893 24.3995C19.6164 26.3 19.5872 26.9125 18.721 26.9906C17.742 27.079 17.8928 25.5088 17.4082 24.5514Z",
    fill: "currentColor",
    fillOpacity: 0.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_27_5422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.6384,
    cy: 62.4802,
    r: 1.5,
    transform: "rotate(-87.801 43.6384 62.4802)",
    fill: "currentColor",
    fillOpacity: 0.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_27_5422)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.6184,
    cy: 36.9223,
    rx: 1,
    ry: 0.5,
    transform: "rotate(-87.801 42.6184 36.9223)",
    fill: "currentColor",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_27_5422",
    x: 16.0582,
    y: 31.7836,
    width: 54.1218,
    height: 31.8418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_27_5422"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_27_5422",
    x: 12.6137,
    y: 16.9701,
    width: 12.0251,
    height: 12.0242,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_27_5422"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_27_5422",
    x: 40.1384,
    y: 58.9801,
    width: 7.00005,
    height: 7.00012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_27_5422"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_27_5422",
    x: 40.1173,
    y: 33.9229,
    width: 5.00224,
    height: 5.9989,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_27_5422"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSecondLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/secondLeft.9fcc9d81.svg";
export { ForwardRef as ReactComponent };